export { default } from './ServicesInfoItem';
